'use strict';
jQuery($ => {

class CareCounter {
	constructor(counter) {
        this.container = counter;
        this.counter = counter.querySelector('.care-counter__counter');

        this.value = Number(this.counter.getAttribute('data-value'));
        this.formatValue();

        this.visible = false;

        // Start a scroll loop to watch for full visibility
        this.lastPosition = -1;
        requestAnimationFrame(() => {
            this.loop();
        });
    }

    loop() {
        if (this.visible) {
            return false;
        }
        if (this.lastPosition == window.pageYOffset) {
            requestAnimationFrame(() => {
                this.loop();
            });
            return false;
        } else {
            this.lastPosition = window.pageYOffset;
            this.checkVisibility();
        }
        requestAnimationFrame(() => {
            this.loop();
        });
    }

    checkVisibility() {
        // Viewport dimensions
        const screenTop = window.pageYOffset;
        const screenBottom = screenTop + document.documentElement.clientHeight;

        // Container dimensions
        const height = $(this.container).outerHeight();
        const elTop = Math.ceil( $(this.container).offset().top );
        const elBottom = elTop + height;

        this.visible = (elTop > screenTop && elBottom < screenBottom);
        const status = (this.visible) ? 'active' : 'inactive';
        this.container.setAttribute('data-status', status);
    }

    formatValue() {
        // Create a string of the specified value
        const value = this.value.toString().trim();
        // Start the comma counter at 1
        let commaCounter = 1;
        // Start with an empty value array
        let valueArray = [];
        // Reverse loop through all characters of the processed string
        for (let i = value.length - 1; i >= 0; i--) {
            // Push the character into the array
            valueArray.push(value.charAt(i));

            // Trigger actions after every 3rd digit
            if (commaCounter >= 3) {
                // Reset the comma counter
                commaCounter = 1;
                // Add a comma character to the array
                valueArray.push(',');
            } else {
                // Increment the comma counter
                commaCounter = commaCounter + 1;
            }
        }
        // We now un-reverse the array created via the reverse loop
        valueArray.reverse();

        // Loop through the characters of the valueArray
        for (let i = 0; i < valueArray.length; i++) {
            if (valueArray[i] != "") { // Not empty validation
                // Create a new child element to house the character
                let newChild = document.createElement('span');
                // Is the character a comma?
                const comma = (valueArray[i] === ',');
                // Set the innerHTML of the child element
                newChild.innerHTML = valueArray[i];
                // Set the base BEM class
                const bemClass = 'care-counter__digit';
                // Add the basic BEM class to the child
                newChild.classList.add(bemClass);
                // Determine which class to add to the child
                const newChildClass = (comma) ? bemClass + '--comma' : bemClass + '--number'
                // Add the new class to the child
                newChild.classList.add(newChildClass);
                // Append the new child to the counter element
                this.counter.appendChild(newChild);
            }
        }
    }
}

$(document).ready(() => {
	// Find the 'Devices' section on document ready
	const counters = document.querySelectorAll('.care-counter__container');

	if (counters) {
        // Set up the canvas if element exists
        for (const counter in counters) {
            if (counters.hasOwnProperty(counter)) {
                const element = counters[counter];
                const careCounter = new CareCounter(element);
            }
        }
    }
});

});